import React, { useState } from 'react';
import axios from 'axios';
import { TextField, Button, Container, Typography, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import zxcvbn from 'zxcvbn';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Register = ({ onRegister, onLogin }) => {
    const [username, setUsername] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [passwordStrength, setPasswordStrength] = useState(0);
    const [showPassword, setShowPassword] = useState(false);
    const [errors, setErrors] = useState({});

    const handlePasswordChange = (e) => {
        const password = e.target.value;
        setPassword(password);
        const strength = zxcvbn(password).score;
        setPasswordStrength(strength);
    };

    const validate = () => {
        const newErrors = {};
        if (!username) newErrors.username = 'Username is required';
        if (!email) newErrors.email = 'Email is required';
        else if (!/\S+@\S+\.\S+/.test(email)) newErrors.email = 'Email is invalid';
        if (!password) newErrors.password = 'Password is required';
        else if (passwordStrength < 2) newErrors.password = 'Password is too weak';
        return newErrors;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        const newErrors = validate();
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setErrors({});
        try {
            const emailCheck = await axios.get(`https://api.typecopy.co.za/api/Users/email/${email}`);
            const usernameCheck = await axios.get(`https://api.typecopy.co.za/api/Users/username/${username}`);
    
            if (emailCheck.data.exists) {
                toast.error('Email already exists');
                return;
            }
            if (usernameCheck.data.exists) {
                toast.error('Username already exists');
                return;
            }
    
            const response = await axios.post('https://api.typecopy.co.za/api/Users', {
                username,
                email,
                password, // Send plain text password
            });
    
            toast.success('You have been registered successfully');
            setUsername('');
            setEmail('');
            setPassword('');
            setPasswordStrength(0);
            console.log('User registered:', response.data);
    
            // Automatically log in the user after registration
            const user = response.data;
            onLogin(user);
            onRegister();
        } catch (error) {
            console.error('There was an error registering the user!', error);
            toast.error('There was an error registering the user');
        }
    };

    const getPasswordStrengthColor = () => {
        switch (passwordStrength) {
            case 0:
            case 1:
                return '#DB1100'; // Red
            case 2:
                return '#FF7300'; // Orange
            case 3:
                return '#FFDA01'; // Dark Yellow
            case 4:
                return '#0ACA00'; // Light Green
            default:
                return '';
        }
    };

    const handleClickShowPassword = () => {
        setShowPassword(!showPassword);
    };

    return (
        <Container>
            <Typography variant="h4" gutterBottom>
                Register
            </Typography>
            <form onSubmit={handleSubmit}>
                <TextField
                    label="Username"
                    fullWidth
                    margin="normal"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    error={!!errors.username}
                    helperText={errors.username}
                    required
                />
                <TextField
                    label="Email"
                    type="email"
                    fullWidth
                    margin="normal"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    error={!!errors.email}
                    helperText={errors.email}
                    required
                />
                <TextField
                    label="Password"
                    type={showPassword ? 'text' : 'password'}
                    fullWidth
                    margin="normal"
                    value={password}
                    onChange={handlePasswordChange}
                    error={!!errors.password}
                    helperText={errors.password}
                    required
                    InputProps={{
                        style: {
                            borderColor: getPasswordStrengthColor(),
                            borderWidth: '3px',
                            borderStyle: 'solid',
                        },
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    aria-label="toggle password visibility"
                                    onClick={handleClickShowPassword}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <Button type="submit" variant="contained" color="primary">
                    Register
                </Button>
            </form>
            <ToastContainer />
        </Container>
    );
};

export default Register;